import { HasAccess } from "@permify/react-role";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
} from "antd";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

const ConclusionsModal = ({
  recommendatiosModal,
}) => {
  const { t } = useTranslation();
  const {
    countryIndication,
    countrySuggestion,
    diagnostic,
    modalVisible,
    patientFullName,
    form,
    closeModal,
    addConclusions,
    list,
    loading,
    filteredConclusions,
    setFilteredConclusions,
    onCheck,
    searchConclusion,
  } = recommendatiosModal;

  const customTableHeader = () => (
    <Row className="table-header">
      <Col
        lg={1}
        className="p-10"
      />
      <Col
        lg={4}
        className="p-10"
      >
        <h3>Código</h3>
      </Col>
      <Col
        lg={19}
        className="p-10"
      >
        <h3>Resultado</h3>
      </Col>
    </Row>
  );

  return (
    <Fragment>
      {modalVisible &&
        <Modal
          visible={modalVisible.state}
          onCancel={closeModal}
          centered
          closable
          footer={false}
          width={'80vw'}
          style={{ maxHeight: '90vh' }}
          className="conclusions-modal"
          zIndex={1001}
        >
          <Row justify="center" className="pt-20 pb-10 pl-lg-15 pr-lg-15">
            {
              loading ?
                <Spin className="cmt-spin" />
                :
                filteredConclusions &&
                <Col lg={24} xs={24}>
                  <Form className="cmt-form" form={form} onFinish={addConclusions}>
                    <Row gutter={[0, 15]}>
                      <Col lg={24} xs={24}>
                        <Row justify='space-between'>
                          <Col>
                            <h2 className="mb-0">
                              {
                                modalVisible["type"] === "indication" ?
                                  countryIndication
                                  :
                                  countrySuggestion
                              }
                            </h2>
                          </Col>
                          <Col>
                            <Form.Item name="search" className="mb-0">
                              <Input
                                className="cmt-input-icon"
                                onChange={searchConclusion}
                                allowClear={() => setFilteredConclusions([...list])}
                                placeholder={`Buscar ${modalVisible["type"] === "indication" ?
                                  countryIndication.toLowerCase()
                                  :
                                  countrySuggestion.toLowerCase()}`
                                }
                                style={{ width: '100%' }}
                                size="large"
                                prefix={
                                  <i className="icon-system-search" style={{ color: '#BEBEBE' }} />
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col>
                            <p className="mb-0">
                              {t('medicalConsultations.conclusionsModal.patientTitle')}:&nbsp;
                              <strong className="ml-5">
                                {patientFullName || ''}
                              </strong>
                            </p>
                            {
                              diagnostic &&
                              <p className="mb-0 mt-10">
                                {t('medicalConsultations.conclusionsModal.diagnosticTitle')}:&nbsp;
                                <strong className="ml-5">
                                  {diagnostic.code} - {diagnostic.description}
                                </strong>
                              </p>
                            }
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={24} xs={24}>
                        <Form.Item name="id" className="mb-0">
                          {customTableHeader()}
                          {
                            filteredConclusions?.map((data, index) =>
                              (data.id && data.description) &&
                              <Row
                                className={`table-body ${(index % 2 === 0 && !filteredConclusions[0].id) && 'white'} mb-15`}
                                key={data.id}
                              >
                                <Col
                                  lg={1}
                                  xs={12}
                                  className="center-item-start p-10"
                                >
                                  <Checkbox
                                    value={data.id}
                                    onChange={onCheck}
                                  />
                                </Col>
                                <Col
                                  lg={4}
                                  xs={12}
                                  className="p-10"
                                >
                                  <h3 className="hide-desktop text-center">Código</h3>
                                  <p className="mb-0">{data.code}</p>
                                </Col>
                                <Col
                                  lg={19}
                                  xs={24}
                                  className="p-10"
                                >
                                  <h3 className="hide-desktop text-center">Resultado</h3>
                                  <p className="mb-0">{data.description}</p>
                                </Col>
                              </Row>
                            )
                          }
                        </Form.Item>
                      </Col>
                      <Col lg={24} xs={24}>
                        <Row justify="end" className="mt-15">
                          <Col>
                            <HasAccess
                              roles={['super_usuario', 'branch_office_manager', 'equipo_medico', 'equipo_psicologia', 'doctor', 'direccion_medica']}
                              permissions='add-indictaion-or-suggestion'
                            >
                              <Button
                                htmlType="submit"
                                className="cmt-button primary"
                                type="primary"
                                size="large"
                              >
                                {
                                  modalVisible["type"] === "indication" ?
                                    `Agregar ${countryIndication.toLocaleLowerCase()}`
                                    :
                                    `Agregar ${countrySuggestion.toLocaleLowerCase()}`
                                }
                              </Button>
                            </HasAccess>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </Col>
            }
          </Row>
        </Modal>
      }
    </Fragment>
  );
};

export default ConclusionsModal;
